import React, { useState } from "react";

import { buildChangeViewModel } from "components/util/changes/ChangeView.lib";
import View from "components/util/changes/ChangeView.view";

const CHANGED = ["added", "modified", "removed"];

// A parent stays visible while any descendant matches, so a node is never shown without the
// process it hangs from.
const matchesFilter = (entity, filter) => {
  if (filter == "all") return true;
  if (entity.status == filter) return true;
  return entity.counts[filter] > 0;
};

const hasChanges = (entity) =>
  CHANGED.includes(entity.status) ||
  entity.counts.added > 0 || entity.counts.modified > 0 || entity.counts.removed > 0;

const filterEntities = (entities, filter, isShowingUnchanged) =>
  entities
    .filter((entity) => (isShowingUnchanged || hasChanges(entity)) && matchesFilter(entity, filter))
    .map((entity) => ({
      ...entity,
      children: filterEntities(entity.children, filter, isShowingUnchanged),
    }));

function ChangeView({ preview }) {

  const [filter, setFilter] = useState("all");
  const [isShowingUnchanged, setIsShowingUnchanged] = useState(false);
  const [collapsedKeys, setCollapsedKeys] = useState([]);
  const [expandedItemKeys, setExpandedItemKeys] = useState([]);

  const model = buildChangeViewModel(preview);

  const groups = model.groups
    .map((group) => ({
      ...group,
      entities: filterEntities(group.entities, filter, isShowingUnchanged),
    }))
    .filter((group) => group.entities.length > 0);

  const onClickFilter = (value) => setFilter(value == filter ? "all" : value);

  const onToggleCollapse = (key) =>
    setCollapsedKeys((previous) =>
      previous.includes(key) ? previous.filter((item) => item != key) : [...previous, key]);

  const onToggleItem = (key) =>
    setExpandedItemKeys((previous) =>
      previous.includes(key) ? previous.filter((item) => item != key) : [...previous, key]);

  const onClickCollapseAll = () => {
    const keys = [];
    const walk = (entities) => entities.forEach((entity) => {
      keys.push(entity.key);
      walk(entity.children);
    });
    groups.forEach((group) => walk(group.entities));

    setCollapsedKeys(collapsedKeys.length > 0 ? [] : keys);
  };

  return (
    <View
      groups={groups}
      counts={model.counts}
      isEmpty={model.isEmpty}
      filter={filter}
      isShowingUnchanged={isShowingUnchanged}
      collapsedKeys={collapsedKeys}
      expandedItemKeys={expandedItemKeys}
      onClickFilter={onClickFilter}
      onToggleUnchanged={() => setIsShowingUnchanged(!isShowingUnchanged)}
      onToggleCollapse={onToggleCollapse}
      onToggleItem={onToggleItem}
      onClickCollapseAll={onClickCollapseAll}
    />
  );

}

export default ChangeView;
